import { render, staticRenderFns } from "./CustomersDeleteModal.vue?vue&type=template&id=3ddca531"
import script from "./CustomersDeleteModal.vue?vue&type=script&lang=js"
export * from "./CustomersDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports